module.exports = __webpack_public_path__ + "img/builder-18.d15da3cd.jpg";